import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { HelpModalModule } from 'Angular/features/components/modals/help-modal/help-modal.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';

import { MultiSelectDropdownComponent } from './multi-select-dropdown.component';

@NgModule({
    declarations: [MultiSelectDropdownComponent],
    exports: [MultiSelectDropdownComponent],
    imports: [CommonModule, DisabledModule, FormsModule, HelpModalModule, IconModule],
})
export class MultiSelectDropdownModule {}
